import { UserModel } from '@modules/auth/user-model';

const fields = new UserModel().fields();

export default [
  fields.id,
  fields.email,
  fields.fullName,
  fields.phoneNumber,
  fields.avatarsIam,
  fields.roles,
  fields.disabled,
  fields.createdAt,
];
